import request from '@/utils/request';
//查询xiangqing
export function getQueryOrderDetail(param) {
  return request('/activityPoints/queryOrderDetail', {
    method: 'POST',
    data: param,
  });
}
//更新xiangqing
export function updateOrder(param) {
  return request('/activityPoints/updateOrder', {
    method: 'POST',
    data: param,
  });
}
